export default "__VITE_ASSET__CvTxvK8l__"